import { render } from "./CandlestickChart.vue?vue&type=template&id=37006954&scoped=true"
import script from "./CandlestickChart.vue?vue&type=script&lang=js"
export * from "./CandlestickChart.vue?vue&type=script&lang=js"

import "./CandlestickChart.vue?vue&type=style&index=0&id=37006954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37006954"]])

export default __exports__